const viewsChart: { [key: string]: string } = {
    Bar: 'Bar',
    Pie: 'Pie',
    Doughnut: 'Doughnut',
    Radar: 'Radar',
  }
  
  export default viewsChart
  